import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Tenders</h1>
                <p>Home &gt; Tenders</p>
            </div>
        </div>
    )
}

export default Hero;